import $ from 'jquery';
import React from 'react';
import CatalogFilterLightboxViewStore from '../../_flux/stores/catalog_filter_lightbox_view_store';
import CatalogFilterStore from '../../_flux/stores/catalog_filter_store/tyre';
import { getCatalogFilterOptionsStoreByProductType } from '../../_flux/stores/catalog_filter_options_store/factory';
import { types as productTypes } from '../../_constants/product/types';
import CatalogMobileFilterVisibilityStore from '../../_flux/stores/catalog_mobile_filter_visibility_store';
import CatalogConditionalFiltersStore from '../../_flux/stores/catalog_conditional_options_store';
import CatalogFilterProvisionalStore from '../../_flux/stores/catalog_filter_provisional_state_store';
import {
    openSectionContentsAction,
    closeSectionContentsAction
} from '../../_flux/actions/catalog_filter_lightbox_view_actions';
import { Tyre } from '../../_flux/components/catalog_filters/filters_lightbox/tyre';
import { updateFiltersAction } from '../../_flux/actions/catalog_filter_actions';
import { hideMobileFiltersAction } from '../../_flux/actions/catalog_mobile_filter_visibility_actions';
import { setFilter, setSectionFilter } from '../../_flux/actions/catalog_filter_provisional_filter_actions';
import { Filters } from '../../_flux/constants/filter/filters';
import { loadingOptionsAction, updateFilterOptionsAction } from '../../_flux/actions/filter_options_actions';
import { requestConfiguratorOptions } from '../../_modules/requests/request_configurator_options';
import { requestSaveVehicleTyreSelection } from '../../_modules/requests/request_save_vehicle_tyre_selection';
import { getFiltersByFilterSection } from '../../_flux/helper/filters/get_filters_by_filter_section';
import { getDefaultValueForFilter } from '../../_flux/helper/filters/get_default_value_for_filter';
import { CatalogMobileFiltersGoogleAnalytics } from '../../_modules/google_analytics/catalog/mobile_filters';
import { handleView } from '../handle_view';
import { applyFilters } from '../../_flux/helper/apply_filters';
import RegoLookupStore from '../../_flux/stores/rego_lookup_store';
import VehicleFilterStore from '../../_flux/stores/vehicle_configurator_store';
import { getAbsoluteValueForSpeedIndex } from '../../_modules/tyre_index/get_absolute_value_for_speed_index';
import { isMatch, pick } from '../../../lib/utilities';
import { TyreIndex } from '../../_flux/components/catalog_filters/filters_column/filter_sections/tyre_index';

const stores = {
    catalogFilterLightboxViewState: CatalogFilterLightboxViewStore,
    catalogFilterState: CatalogFilterStore,
    catalogConditionalFiltersState: CatalogConditionalFiltersStore,
    catalogMobileFilterVisibilityState: CatalogMobileFilterVisibilityStore,
    catalogFilterProvisionalState: CatalogFilterProvisionalStore,
    regoLookupStore: RegoLookupStore,
    vehicleConfiguratorStore: VehicleFilterStore,
    filterOptionsState: getCatalogFilterOptionsStoreByProductType(productTypes.TYRE_CAR),
};

function render(
    {
        catalogFilterLightboxViewState,
        catalogConditionalFiltersState: conditionalFilters,
        catalogMobileFilterVisibilityState,
        catalogFilterProvisionalState: catalogFilterProvisionalStore,
        filterOptionsState: filterOptions,
    },
    options
) {
    const { sectionVisibility } = catalogFilterLightboxViewState;
    const { isVisible: visible } = catalogMobileFilterVisibilityState;
    const filterValues = {
        ...catalogFilterProvisionalStore.provisionalFilters,
        ...(sectionVisibility === '' ? {} : catalogFilterProvisionalStore.sectionFilters)
    };

    return (
        <Tyre
            sectionVisibility={sectionVisibility}
            visible={visible}
            filterValues={filterValues}
            filterOptions={filterOptions}
            conditionalFilters={conditionalFilters}
            currencyIsoCode={options.currencyIsoCode}
            displayDimensions={options.displayDimensions}
            onChangeCallback={onFilterChange}
            onShowFilterView={openSection}
            onSave={saveSectionFilters}
            onClose={resetSectionFilters}
            onApply={options.onApplyProvisionalFilters}
            onResetAndCloseClick={onResetAndCloseLightbox}
            onResetFilterCompletely={onResetFilterCompletely}
            onVehicleTyreChange={onVehicleTyreFilterChange}
        />
    );
}

const getOptions = options => ({
    ...options,
    onApplyProvisionalFilters: onApplyProvisionalFilters.bind(null, options.productType),
});

export const init = (container, options) => {
    handleView(stores, render, getOptions(options), container);
    handleScrollWhenMobileFiltersOpened();
};

function openSection(sectionName) {
    openSectionContentsAction(sectionName);
    CatalogMobileFiltersGoogleAnalytics.openSection(sectionName);
}

function saveSectionFilters(sectionName) {
    const changedFilters = getFiltersByFilterSection(sectionName);
    setFilter(pick(CatalogFilterProvisionalStore.getState().sectionFilters, changedFilters));
    closeSectionContentsAction();
    CatalogMobileFiltersGoogleAnalytics.saveSectionFilters();
}

function resetSectionFilters(sectionName) {
    if (sectionName) {
        const changedFilters = getFiltersByFilterSection(sectionName);
        setSectionFilter(pick(CatalogFilterProvisionalStore.getState().provisionalFilters, changedFilters));
    }
    closeSectionContentsAction();
    loadFilterOptions(Filters.MANUFACTURER);
    CatalogMobileFiltersGoogleAnalytics.resetSectionFilters();
}

function onVehicleTyreFilterChange(value) {
    if (value.length > 0 && value.includes('|')) {
        let tyreSize = value.split('|');
        let filters = {
            [Filters.WIDTH]: tyreSize[0],
            [Filters.HEIGHT]: tyreSize[1],
            [Filters.DIAMETER]: tyreSize[2],
            [Filters.POSTCODE]: '',
        };

        if (tyreSize[4] && tyreSize[4].length > 0 && tyreSize[4] !== 'undefined') {
            filters[Filters.LOAD_INDEX] = parseInt(tyreSize[4]);
        }

        let speedIndexAbsValue = getAbsoluteValueForSpeedIndex(tyreSize[5]);
        if (Number.isInteger(speedIndexAbsValue) && speedIndexAbsValue > 0) {
            filters[Filters.SPEED_INDEX] = speedIndexAbsValue;
        }

        requestSaveVehicleTyreSelection(value).then(() => {
            updateFiltersAction(filters);
            applyFilters('tyre');
        }).catch(() => {
        });
    }
}

function onFilterChange(value, filterName, props) {
    if (filterName === Filters.SPEED_INDEX || filterName === Filters.LOAD_INDEX) {
        value = parseInt(value, 10);
    }
    setSectionFilter({ [filterName]: value }, true);
    unsetDependingFieldsOnReset(filterName);
    loadFilterOptions(filterName);
    CatalogMobileFiltersGoogleAnalytics.filterChange(filterName, value, TYROOLA.globals.currencyIsoCode, props);
}

function onResetFilterCompletely(filterName) {
    setSectionFilter({ [filterName]: getDefaultValueForFilter(filterName) });
    setFilter({ [filterName]: getDefaultValueForFilter(filterName) });
    CatalogMobileFiltersGoogleAnalytics.unsetFilters();
}

function onResetAndCloseLightbox() {
    const filters = CatalogFilterStore.getState();

    setSectionFilter(filters);
    setFilter(filters);
    hideMobileFiltersAction();
    CatalogMobileFiltersGoogleAnalytics.resetAllFiltersAndClose();
}

const onApplyProvisionalFilters = productType => {
    const currentFilters = CatalogFilterStore.getState();
    const provisionalFilters = CatalogFilterProvisionalStore.getState().provisionalFilters;

    if (!isMatch(provisionalFilters, currentFilters)) {
        updateFiltersAction(CatalogFilterProvisionalStore.getState().provisionalFilters);
        applyFilters(productType);
        CatalogMobileFiltersGoogleAnalytics.applyFilters();
    }

    hideMobileFiltersAction();
};

function handleScrollWhenMobileFiltersOpened() {
    const $body = $(document.body);
    let opened = CatalogMobileFilterVisibilityStore.getState().isVisible;

    CatalogMobileFilterVisibilityStore.addListener(() => {
        const newVisibleState = CatalogMobileFilterVisibilityStore.getState().isVisible;
        if (newVisibleState !== opened) {
            opened = newVisibleState;
            $body.toggleClass('no-scroll', opened);
        }
    });
}

function loadFilterOptions(filterName) {
    if (Filters.MANUFACTURER === filterName) {
        loadingOptionsAction([Filters.MODEL]);
        requestConfiguratorOptions(
            {
                [Filters.MANUFACTURER]: CatalogFilterProvisionalStore
                    .getState().sectionFilters[Filters.MANUFACTURER]
            },
            [Filters.MODEL]
        ).then((options) => {
            updateFilterOptionsAction(options);
        });
    }
}

function unsetDependingFieldsOnReset(filterName) {
    if (Filters.MANUFACTURER) {
        let manufacturerValue = CatalogFilterProvisionalStore.getState().sectionFilters[Filters.MANUFACTURER];
        if (manufacturerValue === '') {
            setSectionFilter({ [Filters.MODEL]: '' });
        }
    }
}
